module.exports = __webpack_public_path__ + "img/Mwd.19570b08.svg";